module.exports = __webpack_public_path__ + "static/media/roop-mantra.a7684fec.png";